import React, { useContext, useEffect, useState } from "react";

/* plugin */
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import axios from "axios";
import { motion } from "framer-motion";
import DOMPurify from "dompurify";
import { Base64 } from "js-base64";
import Modal from "react-bootstrap/Modal";
/* plugin end */

/* service */
import { stepFun, toasterConfig } from "../../utils/Constant";
import AuthContext from "../../store/auth-context";
import gs from "../../services/global";
/* service end */

/* component */
import Header from "../../components/Header";
import ApprovedLoadComp from "../../components/ApprovedLoadComp";
import ErrorMsgComp from "../../components/ErrorMsgComp";
import InnerBgComp from "../../components/InnerBgComp";
import PopupContentComp from "../../components/PopupContentComp";
/* component end */

const { REACT_APP_FLOWID } = process.env;

const FinalizeLoanDetail = () => {
  const authCtx = useContext(AuthContext);
  const instanceId = authCtx?.instanceId;
  const navigate = useNavigate();

  /* react-form-hook */
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "all",
  });
  /* react-form-hook end */

  /* usestate */
  const [document, setDocument] = useState(null);
  const [privacyModal, setPrivacyModal] = useState(false);
  let loanagreementDoc =
    document?.loan_agreement && Base64.decode(document?.loan_agreement);
  let adequateExplanationsDoc =
    document?.adequate_explanations &&
    Base64.decode(document?.adequate_explanations);
  let secciDoc = document?.secci && Base64.decode(document?.secci);
  const termDocData = JSON.parse(localStorage.getItem("termDocument"));
  let privacyDocument =
    termDocData?.privacy_policy && Base64.decode(termDocData?.privacy_policy);
  /* usestate end */

  /* Post data */
  const onSubmit = (data) => {
    let inputData = data;

    let payload = {
      action: "submit",
      data: {
        preContractConsent: inputData?.preContractConsent,
        agreementConsent: inputData?.agreementConsent,
        preContractInformation: inputData?.preContractInformation,
      },
    };

    /* Loader Starts */
    gs.showLoader(true);
    /* Loader Ends */

    axios
      .post(`/flow/${REACT_APP_FLOWID}/instances/${instanceId}`, payload)
      .then((response) => {
        const result = response?.data;
        const currentStep = result?.currentStepId;
        navigate(stepFun()[currentStep], { replace: true });
        authCtx.prefilledDataFunc(result?.prefilledData);

        /* Loader Starts */
        gs.showLoader(false);
        /* Loader Ends */

        toast.success("Your all set", toasterConfig);
      })
      .catch((error) => {
        const errorEnd = error?.response?.data?.currentStepId;
        navigate(stepFun()[errorEnd], { replace: true });

        /* Loader Starts */
        gs.showLoader(false);
        /* Loader Ends */

        toast.error("Something went wrong!", toasterConfig);
      });
  };
  /* Post data end */

  useEffect(() => {
    /* Loader Starts */
    gs.showLoader(true);
    /* Loader Ends */

    let payload = {
      action: "fetch",
      data: {},
    };

    axios
      .post(`/flow/${REACT_APP_FLOWID}/instances/${instanceId}`, payload)
      .then((response) => {
        const result = response?.data?.responseData;
        setDocument(result);

        /* Loader Starts */
        gs.showLoader(false);
        /* Loader Ends */
      })
      .catch(() => {
        /* Loader Starts */
        gs.showLoader(false);
        /* Loader Ends */
      });
  }, []);

  return (
    <div>
      {/* Header Starts */}
      <Header />
      {/* Header Ends */}

      {/* Main Container Starts */}
      <div className="main-container">
        <InnerBgComp classes={"inner-bg-img"} />

        <div className="container">
          {/* start */}
          <div className="welcome-box">
            <motion.div
              initial={{ y: 60, scale: 0.9, opacity: 0 }}
              animate={{ y: 0, scale: 1, opacity: 1 }}
              transition={{ duration: 0.5 }}
              className="welcome-right"
            >
              {/* start */}
              <ApprovedLoadComp />
              {/* end */}
            </motion.div>

            <motion.div
              initial={{ y: 60, scale: 0.9, opacity: 0 }}
              animate={{ y: 0, scale: 1, opacity: 1 }}
              transition={{ duration: 0.5 }}
              className="welcome-left"
            >
              {/* start */}
              <div className="comm-box">
                <div className="comm-hdn-box">
                  <h3 className="comm-hdn">Your loan terms & conditions</h3>
                  <div className="comm-para">
                    <p>Please review and confirm your loan terms.</p>
                  </div>
                </div>

                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="term-main-box">
                    <div className="form-quest-box">
                      <h6 className="form-quest">Pre-contract information</h6>
                    </div>
                    <div className="term-height mb0">
                      <div className="term-box comm-scroll">
                        {secciDoc && (
                          <div
                            className="term-content"
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(secciDoc),
                            }}
                          />
                        )}
                      </div>
                      {/* start */}
                      <div className="chk-main-term">
                        <div className="check-box chk-border-black mb0">
                          <input
                            type="checkbox"
                            id="preContractInformation"
                            name="preContractInformation"
                            {...register("preContractInformation", {
                              required:
                                "Pre-contract information consent is required",
                            })}
                          />
                          <label
                            className="check-label"
                            htmlFor="preContractInformation"
                          >
                            I have read and agree to the terms & conditions of
                            the pre-contract information.
                          </label>
                        </div>
                      </div>
                      {/* end */}
                    </div>
                    {errors.preContractInformation && (
                      <ErrorMsgComp
                        errorMessage={errors.preContractInformation.message}
                      />
                    )}
                  </div>
                  <div className="term-main-box">
                    <div className="form-quest-box">
                      <p className="form-quest">Loan agreement</p>
                    </div>
                    <div className="term-height mb0">
                      <div className="term-box comm-scroll">
                        {loanagreementDoc && (
                          <div
                            className="term-content"
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(loanagreementDoc),
                            }}
                          />
                        )}
                      </div>
                      {/* start */}
                      <div className="chk-main-term">
                        <div className="check-box chk-border-black mb0">
                          <input
                            type="checkbox"
                            id="preContractConsent"
                            name="preContractConsent"
                            {...register("preContractConsent", {
                              required: "Loan agreement consent is required",
                            })}
                          />
                          <label
                            className="check-label"
                            htmlFor="preContractConsent"
                          >
                            I have read and agree to the terms & conditions of
                            the Loan agreement.
                          </label>
                        </div>
                      </div>
                      {/* end */}
                    </div>
                    {errors.preContractConsent && (
                      <ErrorMsgComp
                        errorMessage={errors.preContractConsent.message}
                      />
                    )}
                  </div>
                  <div className="term-main-box">
                    <div className="form-quest-box">
                      <h6 className="form-quest">Adequate explanations</h6>
                      <div className="form-para">
                        <p>Your Creditstar loan contract summary</p>
                      </div>
                    </div>
                    <div className="term-height mb0">
                      <div className="term-box comm-scroll">
                        {adequateExplanationsDoc && (
                          <div
                            className="term-content"
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(
                                adequateExplanationsDoc
                              ),
                            }}
                          />
                        )}
                      </div>
                      {/* start */}
                      <div className="chk-main-term">
                        <div className="check-box chk-border-black mb0">
                          <input
                            type="checkbox"
                            id="agreementConsent"
                            name="agreementConsent"
                            {...register("agreementConsent", {
                              required:
                                "Adequate explanations consent is required",
                            })}
                          />
                          <label
                            className="check-label"
                            htmlFor="agreementConsent"
                          >
                            I have read and fully understand the explanation of
                            the fixed sum Loan agreement.
                          </label>
                        </div>
                      </div>
                      {/* end */}
                    </div>
                    {errors.agreementConsent && (
                      <ErrorMsgComp
                        errorMessage={errors.agreementConsent.message}
                      />
                    )}
                  </div>
                  <div className="comm-disclaim">
                    <p>
                      We use your personal information to set up and administer
                      your loan. For detailed information about how we process
                      your personal data and including why we share your
                      information with credit reference agencies (CRAs) and
                      fraud prevention services, please refer to our{" "}
                      <a href="#!" onClick={() => setPrivacyModal(true)}>
                        Privacy Notice
                      </a>
                      .
                    </p>
                  </div>

                  <button className="button button--block">Finish</button>
                </form>
              </div>
              {/* end */}
            </motion.div>
          </div>
          {/* end */}
        </div>
      </div>
      {/* Main Container Ends */}

      {/* Privacy popup */}
      <Modal
        className="comm-modal"
        show={privacyModal}
        onHide={() => setPrivacyModal(false)}
      >
        <PopupContentComp
          modalTitle={"Privacy Policy"}
          modalContent={privacyDocument}
          onClick={() => setPrivacyModal(false)}
        />
      </Modal>
      {/* Privacy popup end */}
    </div>
  );
};

export default FinalizeLoanDetail;
